import React, { useContext } from 'react';
import { Typography } from 'antd';
import TransparentOverlay from '~/App/components/TransparentOverlay';
import { OrderDetail } from '~/types/Order';
import usePrintButton from './usePrintButton';
import useVoidButton from './useVoidButton';
import useAddButton from './useAddButton';
import usePayButton from './usePayButton';
import PageContext from '../../context';
import useChecklistButton from './useChecklistButton';
import { useCheckPermission } from '~/store/permission';
import { Order } from '@restaurant/api';
import { OrderStatus, OrderType } from '@restaurant/types';
import useIndentPayButton from './useIndentPayButton';
import useCloseButton from './useCloseButton';

const BottomBar = ({ order }: { order: Order }) => {
  const { paid } = useContext(PageContext);
  const voidButton = useVoidButton({ order });
  const printButton = usePrintButton(order.orderId);
  const addButton = useAddButton({ order });
  const payButton = usePayButton({ order });
  const indentPayButton = useIndentPayButton({ order });
  const checklistButton = useChecklistButton({ order });
  const checkPermission = useCheckPermission();
  const closeButton = useCloseButton({ order });

  const buttons = (() => {
    if (order.status !== OrderStatus.Open) {
      return [];
    }

    const items = [];
    if (checkPermission('orderVoid:u')) {
      items.push(voidButton);
    }
    if (checkPermission('orderReceiptPrintCashier:r')) {
      items.push(printButton);
    }

    items.push(addButton, checklistButton);

    if (checkPermission('orderPayment:c')) {
      items.push(
        order.orderType === OrderType.Indent ? indentPayButton : payButton
      );
    }

    if (
      checkPermission('orderClose:u') &&
      order.orderType === OrderType.Indent
    ) {
      items.push(closeButton);
    }

    return items;
  })();

  return (
    <div className="cart-bottom-bar-row flex">
      <TransparentOverlay show={paid || order.status !== OrderStatus.Open} />
      {buttons.map(({ key, text, icon, onClick }) => (
        <div
          className="flex-1 flex flex-col items-center py-2 cursor-pointer text-center hover:bg-neutral-50 transition-colors"
          key={key}
          onClick={onClick}
        >
          {icon}
          <p className="mb-0">{text}</p>
        </div>
      ))}
    </div>
  );
};

export default BottomBar;
